import {Pipe, PipeTransform} from '@angular/core';
import {Utils} from "../utils/utils";

@Pipe({
    name: 'count',
    standalone: false
})
export class CountPipe implements PipeTransform {

  transform(count: number, countData: any = {}): string {
    return Utils.countToString(count, countData.unit);
  }

}
